<ng-select
  [items]="countries"
  bindLabel="name"
  bindValue="code"
  [ngModel]="selectedValue"
  (change)="onCountryChange($event)"
></ng-select>
